<template>
  <div class="campuses">
    <Head></Head>
    <div class="content">
      <div class="breadcrumb">
        <router-link :to="{ path: '/' }">首页</router-link> >
        <div>{{ schoolList[schoolId - 1].name }}</div>
      </div>
      <div class="swiper-container banner">
        <div class="swiper-wrapper">
          <div
            v-for="(item, index) in schoolList[schoolId - 1].ImgList"
            :key="index"
            class="swiper-slide"
          >
            <img :src="item" alt="" />
          </div>
        </div>
        <div class="swiper-button-prev s-prev"></div>
        <!--左箭头。如果放置在swiper-container外面，需要自定义样式。-->
        <div class="swiper-button-next s-next"></div>
        <!--右箭头。如果放置在swiper-container外面，需要自定义样式。-->
        <div class="swiper-pagination"></div>
        <!--分页器。如果放置在swiper-container外面，需要自定义样式。-->
      </div>

      <div class="school-info">
        <div class="info-left">
          <div class="school-name">{{ schoolList[schoolId - 1].name }}</div>
          <div class="school-intro">
            {{ schoolList[schoolId - 1].Introduce }}
          </div>
        </div>
        <div class="info-right">
          <div class="wximg">
            <img :src="schoolList[schoolId - 1].wxCode" alt="" />
          </div>
          <div class="tip">扫码咨询课程顾问</div>
        </div>
      </div>

      <div class="special-course">
        <div class="course-wrap">
          <div class="course-l">
            <h3>特色课程 <span>Special</span></h3>
            <h4>
              {{ schoolList[schoolId - 1].courseViews[courseIndex].courseName }}
            </h4>
            <p>
              {{ schoolList[schoolId - 1].courseViews[courseIndex].introduce }}
            </p>
            <h5>详细课表及更多常规课程请咨询课程顾问</h5>
          </div>
          <div class="course-r">
            <div
              @mouseenter="hoverToggle(0, index)"
              @mouseleave="hoverToggle(1, index)"
              v-for="(item, index) in schoolList[schoolId - 1].courseViews"
              :key="index"
              class="course-item"
            >
              <img :src="item.picture" alt="" />
              <div class="item-bottom">
                <h4>{{ item.courseName }}</h4>
                <p v-if="hoverShow && courseIndex == index">
                  {{ item.introduce }}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="campus-teacher">
        <h3>校区师资</h3>
        <div class="teacher-wrap">
          <div
            v-for="(item, index) in schoolList[schoolId - 1].teacherList"
            :key="index"
            class="teacher-item"
          >
            <img :src="item.picture" alt="" />
            <div class="teacher-info">
              <h4>{{ item.name }}</h4>
              <p>{{ item.introduce }}</p>
            </div>
          </div>
        </div>
      </div>

      <div class="t-achievement">
        <h3>教学成果</h3>
        <div class="swiper-container achievement-wrap">
          <div class="swiper-wrapper">
            <div
              v-for="(item, index) in schoolList[schoolId - 1].transcripts"
              :key="index"
              class="achievement-item swiper-slide"
            >
              <img :src="item" alt="" />
            </div>
          </div>
          <div class="swiper-button-prev s-prev"></div>
          <!--左箭头。如果放置在swiper-container外面，需要自定义样式。-->
          <div class="swiper-button-next s-next"></div>
          <!--右箭头。如果放置在swiper-container外面，需要自定义样式。-->
          <div class="swiper-pagination"></div>
          <!--分页器。如果放置在swiper-container外面，需要自定义样式。-->
        </div>
      </div>
    </div>
    <Bottom></Bottom>
  </div>
</template>

<script>
import Swiper from "swiper";
import "swiper/dist/css/swiper.min.css";
import Head from "./../../components/Head";
import Bottom from "./../../components/footer";
export default {
  name: "campuses",
  components: {
    Head,
    Bottom
  },

  data() {
    var transcripts = [
      "/static/img/campus_achievement1.jpg",
      "/static/img/campus_achievement2.jpg",
      "/static/img/campus_achievement3.jpg",
      "/static/img/campus_achievement4.jpg",
      "/static/img/campus_achievement5.jpg",
      "/static/img/campus_achievement6.jpg",
      "/static/img/campus_achievement7.jpg",
      "/static/img/campus_achievement8.jpg"
    ];
    return {
      schoolId: 0,
      courseIndex: 0,
      hoverShow: false,
      schoolList: [
        {
          name: "杭州校区",
          wxCode: "/static/img/YTpte13yun.png",
          ImgList: [
            "/static/img/hangzhou01.jpg",
            "/static/img/hangzhou02.jpg",
            "/static/img/hangzhou03.jpg",
            "/static/img/hangzhou04.jpg",
            "/static/img/hangzhou05.jpg"
          ],
          Introduce:
            "羊驼教育杭州校区位于朝晖路182号国都发展大厦1号楼180A，有完善的自习室、班课教室、VIP教室以及线上授课的电脑机房学习室。为选择不同授课模式的同学提供了完善的配套服务。地理位置处于杭城中心商圈，距离1号线西湖文化广场站直线距离约500米，周边汇集了留学，移民，艺术教育等公司。",
          courseViews: [
            {
              courseName: "单科突破营",
              picture: "/static/img/hangzhouCV01.jpg",
              OneIntroduce: "",
              introduce:
                "适合有一定雅思基础、与目标分数差别不太大、个别科目需要提分、希望可以尽快突击提分的学员"
            },
            {
              courseName: "全科屠鸭营",
              picture: "/static/img/hangzhouCV02.jpg",
              OneIntroduce: "",
              introduce:
                "适合无雅思基础及经验、与目标分数差别较大、自学自律能力较差的学员、学习时间比较充足的学员"
            },
            {
              courseName: "封闭班",
              picture: "/static/img/hangzhouCV03.jpg",
              OneIntroduce: "",
              introduce:
                "适合刚接触雅思的小白或者英语基础不是特别好的同学，多层次、高效率学习，免除外界干扰。夯实语法词汇发音基础，技巧讲解与方法训练，模拟演练，掌握做题原理、获得高分。"
            },
            {
              courseName: "VIP规划班",
              picture: "/static/img/hangzhouCV04.jpg",
              OneIntroduce: "",
              introduce:
                "为备考时间紧迫，考试数次，卡单项，一直无法突破，学习自制力差，需要老师紧盯式监督，上过辅导班，但是一直不知道自己的问题在哪里的学员们根据个人成绩及目标，专属定制课程，也特别适合有一定雅思基础并想要快速出分的同学。由一对一老师专门指导，保证解决顽固性问题，从而快速提分。"
            }
          ],
          teacherList: [
            {
              name: "陈丽",
              picture: "/static/img/hangzhouChenli.jpg",
              introduce:
                "四川外国语大学（SISU）英语文学硕士\n近6年雅思托福一线教学经验，3年PTE教学经验。PTE全科金牌讲师。"
            },
            {
              name: "Greenspan",
              picture: "/static/img/hangzhougreenspan.jpg",
              introduce:
                "6年教学教研管理工作经验，擅长教学评测，国际高中项目教学总监，负责杭州地区某国际高中及国际班招考及教学试卷编纂工作\n组织并负责A-level教辅材料编写"
            },
            {
              name: "Frederic",
              picture: "/static/img/hangzhouFrederic.jpg",
              introduce:
                "高中毕业于杭外剑桥，本科提前毕业于塔夫茨大学并获得国际关系和计量经济双学位托福、SAT、雅思、PTE、GRE、GMAT、ALEVEL等多项考试方面的资深专家"
            }
          ],
          transcripts: transcripts
        },
        {
          name: "南京校区",
          wxCode: "/static/img/YTpte13yun.png",
          ImgList: [
            "/static/img/nanjing01.jpg",
            "/static/img/nanjing02.jpg",
            "/static/img/nanjing03.jpg",
            "/static/img/nanjing04.jpg",
            "/static/img/nanjing05.jpg",
            "/static/img/nanjing06.jpg"
          ],
          Introduce:
            "羊驼教育南京校区位于南京市鼓楼区中山路99号，新街口核心CBD地段，地铁1号线和2号线双地铁口新街口站，辐射南京市各个区域，黄金地段，宇宙中心，教育资源集中，交通便利。我们以工匠精神打造专业出国留学语言培训，提供雅思PTE线下课程培训服务，旨在承诺一个全新的海外求学心意之旅。我们通过提升英语基础、熟练掌握雅思考试技巧、大量针对性的模拟机考和真题实战，帮助学生们短期内有效通过考试。",
          courseViews: [
            {
              courseName: "单科突破营",
              picture: "/static/img/hangzhouCV01.jpg",
              OneIntroduce: "",
              introduce:
                "适合有一定雅思基础、与目标分数差别不太大、个别科目需要提分、希望可以尽快突击提分的学员"
            },
            {
              courseName: "全科屠鸭营",
              picture: "/static/img/hangzhouCV02.jpg",
              OneIntroduce: "",
              introduce:
                "适合无雅思基础及经验、与目标分数差别较大、自学自律能力较差的学员、学习时间比较充足的学员"
            },
            {
              courseName: "封闭班",
              picture: "/static/img/hangzhouCV03.jpg",
              OneIntroduce: "",
              introduce:
                "适合刚接触雅思的小白或者英语基础不是特别好的同学，多层次、高效率学习，免除外界干扰。夯实语法词汇发音基础，技巧讲解与方法训练，模拟演练，掌握做题原理、获得高分。"
            },
            {
              courseName: "VIP规划班",
              picture: "/static/img/hangzhouCV04.jpg",
              OneIntroduce: "",
              introduce:
                "为备考时间紧迫，考试数次，卡单项，一直无法突破，学习自制力差，需要老师紧盯式监督，上过辅导班，但是一直不知道自己的问题在哪里的学员们根据个人成绩及目标，专属定制课程，也特别适合有一定雅思基础并想要快速出分的同学。由一对一老师专门指导，保证解决顽固性问题，从而快速提分。"
            }
          ],
          teacherList: [
            {
              name: "Shirley shi",
              picture: "/static/img/nanjingShirleyShi.jpg",
              introduce:
                "羊驼教育南京校区校长\n澳洲PR永居获得者\n新南威尔士大学 访问学者\n较早一批PTE高分获得者和培生官方认可的教学老师"
            },
            {
              name: "Jessica",
              picture: "/static/img/nanjingJessica.jpg",
              introduce:
                "澳大利亚科廷科技大学 硕士\n系统学习研究过雅思及PTE考试\n擅长口语教学，精通PTE考试技巧\n教授学生各种应试技巧，深得学生青睐。"
            },
            {
              name: "Conner Chan",
              picture: "/static/img/nanjingConnerChan.jpg",
              introduce:
                "英国谢菲尔德大学 硕士  \n善于从考试评分机制上提高学生成绩，及时解答学生的疑问。在口语及听力方面有经验与方法，可以结合学生自身情况选择合适的教学方式。"
            },
            {
              name: "Betty",
              picture: "/static/img/nanjingBetty.jpg",
              introduce:
                "澳洲PR永居获得者\n南京邮电大学\n口语讲师，对高频机精掌握透彻，专治备考疑难杂症，深谙口语听力的提分技巧。\n帮助学生在短期内突破PTE分数瓶颈，帮助学员攻克PTE考试难点"
            },
            {
              name: "Donnie",
              picture: "/static/img/nanjingDonnie.jpg",
              introduce:
                "英国阿斯顿大学硕士\n课程互动丰富多彩，在授课的过程中结合对中西方文化思维的差异，既能通过逻辑清晰的讲解让学生快速地掌握知识要点，发音地道。"
            },
            {
              name: "Gina",
              picture: "/static/img/nanjingGina.jpg",
              introduce:
                "墨尔本大学教育学硕士\n善于从不同材料中寻找对RA和RL的训练有益的内容进行学习。对学员课后的备考状态也有持续跟进，考前互动也能有效帮助学员考出好成绩。"
            }
          ],
          transcripts: transcripts
        },
        {
          name: "深圳校区",
          wxCode: "/static/img/YTpte13yun.png",
          ImgList: [
            "/static/img/shenzhen01.jpg",
            "/static/img/shenzhen02.jpg",
            "/static/img/shenzhen03.jpg",
            "/static/img/shenzhen04.jpg",
            "/static/img/shenzhen05.jpg"
          ],
          Introduce:
            "羊驼深圳雅思校区位于深圳市南山区卫星大厦，毗邻深圳大学、腾讯及百度大厦，交通方便，周边设有科苑地铁站和公交站以及快速路；教学设备齐全，设有VIP教室以及班课教室。面授教师全部拥有海外名校学历，有经验丰富的助教老师全天在校区为学生答疑解惑，督促训练，致力于为学生的雅思考试保驾护航。",
          courseViews: [
            {
              courseName: "单科突破营",
              picture: "/static/img/hangzhouCV01.jpg",
              OneIntroduce: "",
              introduce:
                "适合有一定雅思基础、与目标分数差别不太大、个别科目需要提分、希望可以尽快突击提分的学员"
            },
            {
              courseName: "全科屠鸭营",
              picture: "/static/img/hangzhouCV02.jpg",
              OneIntroduce: "",
              introduce:
                "适合无雅思基础及经验、与目标分数差别较大、自学自律能力较差的学员、学习时间比较充足的学员"
            },
            {
              courseName: "封闭班",
              picture: "/static/img/hangzhouCV03.jpg",
              OneIntroduce: "",
              introduce:
                "适合刚接触雅思的小白或者英语基础不是特别好的同学，多层次、高效率学习，免除外界干扰。夯实语法词汇发音基础，技巧讲解与方法训练，模拟演练，掌握做题原理、获得高分。"
            },
            {
              courseName: "VIP规划班",
              picture: "/static/img/hangzhouCV04.jpg",
              OneIntroduce: "",
              introduce:
                "为备考时间紧迫，考试数次，卡单项，一直无法突破，学习自制力差，需要老师紧盯式监督，上过辅导班，但是一直不知道自己的问题在哪里的学员们根据个人成绩及目标，专属定制课程，也特别适合有一定雅思基础并想要快速出分的同学。由一对一老师专门指导，保证解决顽固性问题，从而快速提分。"
            }
          ],
          teacherList: [
            {
              name: "Helena",
              picture: "/static/img/shenzhenhelena.jpg",
              introduce:
                "澳洲中央昆士兰大学 硕士\nPTE 满分 90\nNatti 二级口译证书\n英语专业八级\n澳大利亚学习生活多年，在澳洲有丰富的教学经验，教学严谨，课程条理清晰。"
            },
            {
              name: "蔡老师",
              picture: "/static/img/shenzhenCaiMan.jpg",
              introduce:
                "上海交大\n澳洲蒙纳士大学\nPTE口语及阅读双满分\n毕业于澳洲八大，多年澳洲教学经验，丰富PTE及大学教学经历。"
            },
            {
              name: "蔡老师",
              picture: "/static/img/shenzhenCaigirl.jpg",
              introduce:
                "本科澳洲国立大学\n硕士澳洲国立大学\n毕业于澳洲八大，多年澳洲学习及教学经验，丰富PTE及雅思备考教学经历。"
            },
            {
              name: "陈老师",
              picture: "/static/img/shenzhenChen.jpg",
              introduce:
                "硕士英国伦敦大学学院（UCL）\nTESOL 专业（英语对外教学）\n英语专业八级\n对PTE写作有专业的教学和辅导方法。"
            },
            {
              name: "Alicia",
              picture: "/static/img/shenzhenAlicia.jpg",
              introduce:
                "香港中文大学硕士\n语言学专业\n雅思听力阅读双满分\n她把自己对留学工作和语言运用的热情和自己丰富的知识和能力，去帮助更多的学生留学和提高学生的英语能力。"
            },
            {
              name: "张老师",
              picture: "/static/img/shenzhenZhang.jpg",
              introduce:
                "法学、英语双学士学位\n雅思听力8.5，阅读9分\n海外经历丰富，有多年海外工作经验\n从事英语教学工作多年，\n风格严谨活泼，实力与技巧并重。"
            }
          ],
          transcripts: transcripts
        },
        {
          name: "天津校区",
          wxCode: "/static/img/YTpte13yun.png",
          ImgList: [
            "/static/img/tianjin01.jpg",
            "/static/img/tianjin02.jpg",
            "/static/img/tianjin03.jpg",
            "/static/img/tianjin04.jpg",
            "/static/img/tianjin05.jpg",
            "/static/img/tianjin06.jpg"
          ],
          Introduce:
            "羊驼雅思天津校区位于天津市和平区博联大厦，毗邻南开大学，天津大学，天津医科大学和天津广播电视台，交通便利，楼下有多条公交线路，临近有西康路和吴家窑地铁站；校区临近北京考场，设备完善，有VIP教室和VIP自习室，授课老师均为世界Top50名校毕业，我们相信顶级师资，顶级人才，羊驼天津校区圆你雅思高分梦。",
          courseViews: [
            {
              courseName: "单科突破营",
              picture: "/static/img/hangzhouCV01.jpg",
              OneIntroduce: "",
              introduce:
                "适合有一定雅思基础、与目标分数差别不太大、个别科目需要提分、希望可以尽快突击提分的学员"
            },
            {
              courseName: "全科屠鸭营",
              picture: "/static/img/hangzhouCV02.jpg",
              OneIntroduce: "",
              introduce:
                "适合无雅思基础及经验、与目标分数差别较大、自学自律能力较差的学员、学习时间比较充足的学员"
            },
            {
              courseName: "封闭班",
              picture: "/static/img/hangzhouCV03.jpg",
              OneIntroduce: "",
              introduce:
                "适合刚接触雅思的小白或者英语基础不是特别好的同学，多层次、高效率学习，免除外界干扰。夯实语法词汇发音基础，技巧讲解与方法训练，模拟演练，掌握做题原理、获得高分。"
            },
            {
              courseName: "VIP规划班",
              picture: "/static/img/hangzhouCV04.jpg",
              OneIntroduce: "",
              introduce:
                "为备考时间紧迫，考试数次，卡单项，一直无法突破，学习自制力差，需要老师紧盯式监督，上过辅导班，但是一直不知道自己的问题在哪里的学员们根据个人成绩及目标，专属定制课程，也特别适合有一定雅思基础并想要快速出分的同学。由一对一老师专门指导，保证解决顽固性问题，从而快速提分。"
            }
          ],
          teacherList: [
            {
              name: "Freddy",
              picture: "/static/img/tianjinFreddy.jpg",
              introduce:
                "加拿大 Simon Fraser University\n教学理念：学习不应知识为了考试服务，更是学生日后在海外生活、学习、工作的基础工具。"
            },
            {
              name: "Carol",
              picture: "/static/img/tianjinCarol.jpg",
              introduce:
                "澳大利亚   The University of Melbourne\n教育学硕士、PTE九炸\n亚欧会议欧洲代表团翻译，美国商会会员。"
            },
            {
              name: "保罗老师",
              picture: "/static/img/tianjinBaoluo.jpg",
              introduce:
                "澳大利亚 University of New South Wales\nPTE九炸、NATTI CCL二级口译\n教学理念：教育不只是传道授业解惑，更重要的是提高学生自我思考的能力。"
            },
            {
              name: "Eileen",
              picture: "/static/img/tianjinEileen.jpg",
              introduce:
                "澳大利亚  The University of Melbourne\n教育学硕士、PTE/雅思口语满分\n教学理念：英文类考试技巧重要，但是理解、心态和坚持更重要。"
            },
            {
              name: "Ming",
              picture: "/static/img/tianjinMing.jpg",
              introduce:
                "英国 UCL\nPTE阅读满分\n8年海外学习、工作经验， 5年英文培训经验\n教学理念：高分是学习目标，英文提升才是最终学习目的。"
            },
            {
              name: "Doris",
              picture: "/static/img/tianjinDoris.jpg",
              introduce:
                "英国  The University of Manchester助教的职责不是简单的检查作业，而是监督学生更正英文学习习惯 “发音习惯，听力习惯，阅读习惯，写作习惯和逻辑习惯”。"
            }
          ],
          transcripts: transcripts
        },
        {
          name: "郑州校区",
          wxCode: "/static/img/YTpte13yun.png",
          ImgList: [
            "/static/img/zhengzhou01.jpg",
            "/static/img/zhengzhou02.jpg",
            "/static/img/zhengzhou03.jpg",
            "/static/img/zhengzhou04.jpg",
            "/static/img/zhengzhou05.jpg",
            "/static/img/zhengzhou06.jpg"
          ],
          Introduce:
            "羊驼河南郑州校区位于郑州东区. 专业的教师团队，设施齐全，优雅的环境，交通生活便利（地铁5号线金水东路站，新田360商场，临近高铁东站，龙子湖大学城.）校区设有：VIP教室，自习室，小班课教室，拥有海外高学位的教师团队，外教，助教，全天候的为学生线上，线下解答问题，督促学生的学习巩固环节. 为广大学子解决语言难关，拿到心仪的offer！",
          courseViews: [
            {
              courseName: "单科突破营",
              picture: "/static/img/hangzhouCV01.jpg",
              OneIntroduce: "",
              introduce:
                "适合有一定雅思基础、与目标分数差别不太大、个别科目需要提分、希望可以尽快突击提分的学员"
            },
            {
              courseName: "全科屠鸭营",
              picture: "/static/img/hangzhouCV02.jpg",
              OneIntroduce: "",
              introduce:
                "适合无雅思基础及经验、与目标分数差别较大、自学自律能力较差的学员、学习时间比较充足的学员"
            },
            {
              courseName: "封闭班",
              picture: "/static/img/hangzhouCV03.jpg",
              OneIntroduce: "",
              introduce:
                "适合刚接触雅思的小白或者英语基础不是特别好的同学，多层次、高效率学习，免除外界干扰。夯实语法词汇发音基础，技巧讲解与方法训练，模拟演练，掌握做题原理、获得高分。"
            },
            {
              courseName: "VIP规划班",
              picture: "/static/img/hangzhouCV04.jpg",
              OneIntroduce: "",
              introduce:
                "为备考时间紧迫，考试数次，卡单项，一直无法突破，学习自制力差，需要老师紧盯式监督，上过辅导班，但是一直不知道自己的问题在哪里的学员们根据个人成绩及目标，专属定制课程，也特别适合有一定雅思基础并想要快速出分的同学。由一对一老师专门指导，保证解决顽固性问题，从而快速提分。"
            }
          ],
          teacherList: [
            {
              name: "Kiwi",
              picture: "/static/img/zhengzhouKIWI.jpg",
              introduce:
                "英国莱斯特大学硕士学位，多年英语教学经验，擅长PTE的综合提升，关注每个学生的学习成长轨迹，能够帮助学生找到学习中存在的问题，并给出针对性的解决方案。"
            },
            {
              name: "鸭嘴兽老师",
              picture: "/static/img/zhengzhouYazs.jpg",
              introduce:
                "在澳从事口译工作多年，英语水平接近母语使用者，CATTI二级口译认证，专业八级，尤其擅长口语发音纠音，在短时间内帮助学生突破口语低分瓶颈。"
            },
            {
              name: "Quokka",
              picture: "/static/img/zhengzhouQuokka.jpg",
              introduce:
                "英国莱斯特大学硕士学位，英语功底深厚，PTE听力及写作教学，因材施教，并结合学生特点对症下药，以专业的教学方式帮助每个学生有效提高专项能力和分数。"
            },
            {
              name: "Nikita",
              picture: "/static/img/zhengzhouNikita.jpg",
              introduce:
                "远东联邦大学测绘学硕士，曾在海外孔子学院任教，担任汉语系研究生口译顾问\nPTE阅读主讲，熟悉出题风格和出题趋势，善于总结做题技巧。"
            },
            {
              name: "小羊老师",
              picture: "/static/img/zhengzhouXiaoyang.jpg",
              introduce:
                "伦敦国王学院优秀毕业生，毕业论文获得distinction荣誉成绩，擅长把“中国式” 的逻辑和论点梳理、归纳，重组为一篇“外国人” 读得懂、给高分的essay。"
            },
            {
              name: "Audie Saili",
              picture: "/static/img/zhengzhouAudie.jpg",
              introduce:
                "新西兰本地人\n丰富的外国教育机构知识和经验\n国际商务学位\n超过7年的雅思和学术英语教学经验"
            }
          ],
          transcripts: transcripts
        }
      ]
    };
  },
  methods: {
    hoverToggle(type, index) {
      if (type == 0) {
        this.courseIndex = index;
        this.hoverShow = true;
      } else {
        this.courseIndex = 0;
        this.hoverShow = false;
      }
    }
  },
  mounted() {
    var banner = new Swiper(".banner", {
      navigation: {
        nextEl: ".s-next",
        prevEl: ".s-prev"
      },

      pagination: {
        el: ".swiper-pagination",
        clickable: true,
        bulletClass: "swiper-pagination-bullet",
        bulletActiveClass: "swiper-pagination-bullet-active"
      },
      autoplay: {
        disableOnInteraction: false,
        delay: 3000
      },
      loop: true
    });

    new Swiper(".achievement-wrap", {
      navigation: {
        nextEl: ".s-next",
        prevEl: ".s-prev"
      },
      slidesPerView: 2,
      spaceBetween: 20,
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
        bulletClass: "swiper-pagination-bullet",
        bulletActiveClass: "swiper-pagination-bullet-active"
      },
      autoplay: {
        disableOnInteraction: false,
        delay: 3000
      },
      loop: true
    });
  },
  created() {
    this.schoolId = this.$route.params.id;
    document.title = "羊驼雅思_" + this.schoolList[this.schoolId - 1].name;
  }
};
</script>

<style>
.banner .swiper-pagination-bullet {
  width: 12px;
  height: 12px;
  display: inline-block;
  border-radius: 100%;
  background: #fff;
  opacity: 1;
  transition: all 0.2s ease;
}

.banner .swiper-pagination-bullet-active {
  width: 26px;
  height: 12px;
  border-radius: 6px;
  background: #53a4f4;
}
</style>
<style lang="stylus" scoped>

.content{
  margin 64px auto 0;
}
.banner{
  max-width 1200px;
  margin-bottom 20px;
  border-radius:5px;
}
.special-course{
  width: 100%;
  height: 300px;
  background: url("/static/img/BG_course_school.png") no-repeat;
  background-position: center;
  margin: 60px 0;
  .course-wrap{
    position:relative;
    max-width:1200px;
    margin 0 auto;
    display flex;
    justify-content space-between;
    align-items center;
    .course-r{
      position: absolute;
      top: -15px;
      right: 0;
      display: flex;
      justify-content: space-between;
      align-items center;
      .course-item{
        width: 200px;
        height: 290px;
        background-color: #ffffff;
        box-shadow: 0px 4px 10px 0px rgba(80, 20, 161, 0.24);
        border-radius: 4px;
        margin-right: 18px;
        cursor: pointer;
        position: relative;
        transition: all .2s ease-out;
        img{
          height: 240px;
          border-radius: 4px 4px 0 0;
          background-color: #eeeeee;
        }
        .item-bottom{
          position: absolute;
          bottom: 0;
          left: 0;
          right: 0;
          height: 50px;
          width: 100%;
          padding: 10px;
          overflow: hidden;
          background: #fff;
          border-radius: 0 0 4px 4px;
          h4{
            font-family:"思源黑体";
            font-size: 16px;
            font-weight: normal;
            font-stretch: normal;
            line-height: 30px;
            letter-spacing: 0px;
            color: #333333;
            text-align: center;
          }
          p{
            font-family:"思源黑体";
            font-size: 14px;
            font-weight: normal;
            font-stretch: normal;
            line-height: 21px;
            letter-spacing: 0px;
            color: #333333;
            overflow: hidden;
            text-overflow: ellipsis;
            -webkit-line-clamp: 2;
            -webkit-box-orient: vertical;
            word-wrap: break-word;
            text-align: justify;
            white-space: normal;
          }
        }
      }
      .course-item:hover{
        height: 320px;
        margin-top: -30px;
        .item-bottom{
          height:100px
          h4{
            color: #7d5fe6;
          }
          p{
            display: -webkit-box;
          }
        }
      }
      .course-item:last-child{
        margin-right:0;
      }
    }
    .course-l{
      color #fff;
      width: 320px;
      height: 245px;
      margin-top: 12px;
      position: relative;
      h3{
        font-family:"思源黑体";
        font-size: 24px;
        font-weight: bold;
        font-stretch: normal;
        line-height: 42px;
        letter-spacing: 0px;
        color: #ffffff;
      }
      h4{
        font-family:"思源黑体";
        font-size: 16px;
        font-weight: normal;
        font-stretch: normal;
        line-height: 36px;
        letter-spacing: 0px;
        color: #ffffff;
      }
      p{
        font-family:"思源黑体";
        font-size: 14px;
        font-weight: normal;
        font-stretch: normal;
        line-height: 24px;
        letter-spacing: 0px;
        color: #ffffff;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 7;
        -webkit-box-orient: vertical;
        word-wrap: break-word;
        text-align: justify;
        white-space: normal;
      }
      h5{
        font-family:"思源黑体";
        font-size: 12px;
        font-weight: normal;
        font-stretch: normal;
        line-height: 24px;
        letter-spacing: 0px;
        color: #ffffff;
        opacity: 0.5;
        position: absolute;
        bottom: -25px;
      }
    }
  }
}
.school-info{
  max-width 1200px;
  display: flex;
  justify-content: space-between;
  align-items:flex-start;
  margin: 30px auto;
  .info-left{
    margin-right: 40px;
    .school-name{
      font-family:"思源黑体";
      font-size: 32px;
      font-weight: bold;
      font-stretch: normal;
      line-height: 42px;
      letter-spacing: 0px;
      color: #1376f8;
      margin-bottom: 10px;
    }
    .school-intro{
      font-family:"思源黑体";
      font-size: 20px;
      font-weight: normal;
      font-stretch: normal;
      line-height: 32px;
      letter-spacing: 0px;
      color: #333333;
      word-wrap: break-word;
      text-align: justify;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 5;
      -webkit-box-orient: vertical;
      white-space: normal;
    }
  }
  .info-right{
    text-align center;
    .wximg{
      width: 182px;
      height: 182px;
    }
    .tip{
      font-family:"思源黑体";
      font-size: 16px;
      font-weight: normal;
      font-stretch: normal;
      letter-spacing: 0px;
      color: #333333;
      text-align: center;
      margin-top: 5px;
    }
  }

}
.breadcrumb{
  max-width 1200px;
  display flex;
  align-items center;
  justify-content flex-start;
  margin 0 auto;
  >*{
    ont-family: SourceHanSansSC-Regular;
    font-size: 16px;
    font-weight: bold;
    font-stretch: normal;
    line-height: 50px;
    letter-spacing: 0px;
    color: #1376f8;
    margin 0 5px;
  }
}
.campus-teacher{
  max-width 1200px;
  margin 20px auto;
  .teacher-wrap{
    display flex;
    justify-content space-between;
    align-items center;
    flex-wrap wrap;
    .teacher-item{
      width: 386px;
      height: 300px;
      background-color: #eeeeee;
      box-shadow: 0px 4px 10px 0px rgba(51, 51, 51, 0.1);
      border-radius: 6px;
      position: relative;
      margin-bottom: 15px;
      position:relative;
      .teacher-info{
        width: 100%;
        height: 120px;
        background: rgba(0,0,0,0.5);
        padding: 12px 20px;
        position: absolute;
        bottom: 0;
        left: 0;
        right: 0;
        border-radius: 0 0 6px 6px;
        transition: all .3s ease;
        opacity: 0;
        h4{
          font-family:"思源黑体";
          font-size: 18px;
          font-weight: normal;
          font-stretch: normal;
          line-height: 24px;
          letter-spacing: 0px;
          color: #ffffff;
          text-align: center;
          margin-bottom: 5px;
        }
        p{
          font-family:"思源黑体";
          font-size: 14px;
          font-weight: normal;
          font-stretch: normal;
          line-height: 21px;
          letter-spacing: 0px;
          color: #ffffff;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 3;
          -webkit-box-orient: vertical;
          word-wrap: break-word;
          text-align: justify;
          white-space: normal;
        }
      }
    }
    .teacher-item:hover{
      .teacher-info{
        opacity: 1!important;
        transition-duration: 0s;
      }
    }
    img{
      border-radius: 6px;
    }
  }
  h3{
    font-family:"思源黑体";
    font-size: 24px;
    font-weight: bold;
    font-stretch: normal;
    line-height: 42px;
    letter-spacing: 0px;
    color: #1376f8;
    text-align: center;
    margin-bottom: 12px;
  }
}
.t-achievement{
  max-width 1200px;
  margin 20px auto;
  .achievement-wrap{
    display flex;
    justify-content space-between;
    align-items center;
    margin:30px 0;
    .achievement-item{
      width: 49%;
      box-shadow: inset 0 0 4px #e0d9f9;
      border-radius: 6px;
      padding:10px;
    }
  }
  h3{
    font-family:"思源黑体";
    font-size: 24px;
    font-weight: bold;
    font-stretch: normal;
    line-height: 42px;
    letter-spacing: 0px;
    color: #1376f8;
    text-align: center;
    margin-bottom: 12px;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/campuses/campuses.vue